import { RequestEvent } from 'common/event';
import { LookupItem } from 'runtime/data/lookupitem';

export class LookupItemByDisplayRequested extends RequestEvent<LookupItemByDisplayRequested, LookupItem> {
    constructor(public fieldName: string, public fieldContext: string, public display: string) {
        super();
    }
}